// // import React from "react";



// // //improved

// // const ReadOnlyRow = ({
// //   isLoadingDelete,
// //   contact,
// //   handleEditClick,
// //   handleDeleteClick,
// //   handleDownloadRow,
// //   selectedRecords,
// //   handleSelectRecord
// // }) => {
// //   return (
// //     <tr className="trrows hover-red bg-white ">
// //       <td className="bg-gold">{contact.id}</td>
// //       <td>{contact.farmerid}</td>
// //       <td>{contact.producttype}</td>
// //       <td>{contact.weight}</td>
// //       <td>{contact.companyname}</td>
// //       <td>{contact.fullname}</td>
// //       <td>{contact.daterecorded}</td><td>
// //   <input
// //     type="checkbox"
// //     checked={selectedRecords.includes(contact.id)}
// //     onChange={() => handleSelectRecord(contact.id)}
// //   />
// // </td>

// //       <td>

// //         <label className="pa4 hover-bg-transparent" onClick={(event) => handleEditClick(event, contact)}>
// //           <i className="fas fa-edit f2 hover-gold"></i>
// //           <span className="ml2"></span>
// //         </label>


// //         <label className="pa4 hover-bg-transparent" onClick={() => handleDownloadRow(contact)}>
// //           <i className="fas fa-download f2 hover-yellow green"></i>
// //           <span className="ml2"></span>
// //         </label>
// //         <label className="pa4 hover-bg-transparent" onClick={() => handleDeleteClick(contact.id)}>
// //           <i className="fas fa-trash f2 hover-yellow red"></i>
// //           <span className="ml2"></span>
// //         </label>
// //       </td>
// //       <td>
// //   {contact.approved_status === "approved" ? (
// //     <span className="green b">Approved</span>
// //   ) : (
// //     <span className="red b">Not Approved</span>
// //   )}
// // </td>

// // <td>{contact.date_approved || "-"}</td>
// //     </tr>
// //   );
// // };

// // export default ReadOnlyRow;



// import React from "react";

// // improved + safe version
// const ReadOnlyRow = ({
//   isLoadingDelete,
//   contact = {},
//   handleEditClick = () => {},
//   handleDeleteClick = () => {},
//   handleDownloadRow = () => {},
//   selectedRecords = [],
//   handleSelectRecord = () => {},
// }) => {
//   const isSelected =
//     Array.isArray(selectedRecords) &&
//     selectedRecords.includes(contact.id);

//   return (
//     <tr className="trrows hover-red bg-white">

//       <td className="bg-gold">{contact?.id ?? "-"}</td>
//       <td>{contact?.farmerid ?? "-"}</td>
//       <td>{contact?.producttype ?? "-"}</td>
//       <td>{contact?.weight ?? "-"}</td>
//       <td>{contact?.companyname ?? "-"}</td>
//       <td>{contact?.fullname ?? "-"}</td>
//       <td>{contact?.daterecorded ?? "-"}</td>

//       {/* checkbox column */}
//       <td>
//         <input
//           type="checkbox"
//           checked={isSelected}
//           onChange={() => handleSelectRecord(contact?.id)}
//         />
//       </td>

//       {/* actions */}
//       <td>
//         <label
//           className="pa4 hover-bg-transparent"
//           onClick={(event) => handleEditClick(event, contact)}
//         >
//           <i className="fas fa-edit f2 hover-gold"></i>
//         </label>

//         <label
//           className="pa4 hover-bg-transparent"
//           onClick={() => handleDownloadRow(contact)}
//         >
//           <i className="fas fa-download f2 hover-yellow green"></i>
//         </label>

//         <label
//           className="pa4 hover-bg-transparent"
//           onClick={() => handleDeleteClick(contact?.id)}
//         >
//           <i className="fas fa-trash f2 hover-yellow red"></i>
//         </label>
//       </td>

//       {/* approval status */}
//       <td>
//         {contact?.approved_status === "approved" ? (
//           <span className="green b">Approved</span>
//         ) : (
//           <span className="red b">Not Approved</span>
//         )}
//       </td>

//       <td>{contact?.date_approved ?? "-"}</td>
//     </tr>
//   );
// };

// export default ReadOnlyRow;

// // neew
// import React from "react";

// const ReadOnlyRow = ({
//   contact,
//   handleEditClick,
//   handleDeleteClick,
//   handleDownloadRow,
//   selectedRecords = [],
//   handleSelectRecord = () => {}
// }) => {
//   const isApproved =
//     contact?.approved_status?.toLowerCase() === "approved";

//   return (
//     <tr className="striped--light-gray hover-bg-near-white">

//       {/* Checkbox */}
//       <td className="pa3 tc">
//         <input
//           type="checkbox"
//           checked={selectedRecords.includes(contact.id)}
//           onChange={() => handleSelectRecord(contact.id)}
//         />
//       </td>

//       {/* ID */}
//       <td className="pa3">
//         {contact.id}
//       </td>

//       {/* Farmer ID */}
//       <td className="pa3">
//         {contact.farmerid}
//       </td>

//       {/* Product */}
//       <td className="pa3">
//         {contact.producttype}
//       </td>

//       {/* Weight */}
//       <td className="pa3 tr">
//         {contact.weight}
//       </td>

//       {/* Company */}
//       <td className="pa3">
//         {contact.companyname}
//       </td>

//       {/* Name */}
//       <td className="pa3">
//         {contact.fullname}
//       </td>

//       {/* Approval */}
//       <td className="pa3 tc">
//         {isApproved ? (
//           <span
//             className="
//               dib
//               br-pill
//               bg-light-green
//               dark-green
//               pa2
//               f6
//               fw6
//             "
//           >
//             Approved
//           </span>
//         ) : (
//           <span
//             className="
//               dib
//               br-pill
//               bg-washed-red
//               dark-red
//               pa2
//               f6
//               fw6
//             "
//           >
//             Not Approved
//           </span>
//         )}
//       </td>

//       {/* Date Approved */}
//       <td className="pa3 tc">
//         {contact.date_approved || "-"}
//       </td>

//       {/* Date Recorded */}
//       <td className="pa3 tc">
//         {contact.daterecorded}
//       </td>

//       {/* Actions */}
//       <td className="pa3 tc nowrap">

//         <label
//           className="pointer mh2"
//           onClick={(event) =>
//             handleEditClick(event, contact)
//           }
//         >
//           <i className="fas fa-edit f4 gold hover-orange"></i>
//         </label>

//         <label
//           className="pointer mh2"
//           onClick={() =>
//             handleDownloadRow(contact)
//           }
//         >
//           <i className="fas fa-download f4 green hover-dark-green"></i>
//         </label>

//         <label
//           className="pointer mh2"
//           onClick={() =>
//             handleDeleteClick(contact.id)
//           }
//         >
//           <i className="fas fa-trash f4 red hover-dark-red"></i>
//         </label>

//       </td>

//     </tr>
//   );
// };

// export default ReadOnlyRow;

// new with working checkboxes
import React from "react";

const ReadOnlyRow = ({
  contact,
  handleEditClick,
  handleDeleteClick,
  handleDownloadRow,
  selectedRecords = [],
  handleSelectRecord = () => {},
}) => {
  const isApproved =
    String(contact?.approved_status || "").toLowerCase() === "approved";

  return (
    <tr
      className="
        striped--light-gray
        hover-bg-near-white
        bb
        b--black-10
      "
    >
      {/* Select */}
      <td className="pa2 tc nowrap">
        <input
          type="checkbox"
          checked={selectedRecords.includes(contact.id)}
          onChange={() => handleSelectRecord(contact.id)}
        />
      </td>

      {/* ID */}
      <td className="pa2 nowrap fw6">
        {contact.id}
      </td>

      {/* Farmer ID */}
      <td className="pa2 nowrap">
        {contact.farmerid}
      </td>

      {/* Product */}
      <td className="pa2 nowrap">
        {contact.producttype}
      </td>

      {/* Weight */}
      <td className="pa2 tr nowrap">
        {contact.weight}
      </td>

      {/* Company */}
      <td className="pa2 nowrap">
        {contact.companyname}
      </td>

      {/* Full Name */}
      <td className="pa2 nowrap">
        {contact.fullname}
      </td>

      {/* Approval */}
      <td className="pa2 tc nowrap">
        {isApproved ? (
          <span
            className="
              dib
              br-pill
              ph3
              pv2
              bg-light-green
              dark-green
              fw6
              f7
              ba
              b--green
            "
          >
            ✓ Approved
          </span>
        ) : (
          <span
            className="
              dib
              br-pill
              ph3
              pv2
              bg-washed-red
              dark-red
              fw6
              f7
              ba
              b--light-red
            "
          >
            ✕ Not Approved
          </span>
        )}
      </td>

      {/* Date Approved */}
      <td className="pa2 tc nowrap">
        {contact.date_approved || "-"}
      </td>

      {/* Date Recorded */}
      <td className="pa2 tc nowrap">
        {contact.daterecorded}
      </td>

      {/* Actions */}
      <td className="pa2 tc nowrap">

        <button
          type="button"
          className="
            bn
            bg-transparent
            pointer
            mh1
          "
          onClick={(event) =>
            handleEditClick(event, contact)
          }
          title="Edit"
        >
          <i className="fas fa-edit f4 gold hover-orange"></i>
        </button>

        <button
          type="button"
          className="
            bn
            bg-transparent
            pointer
            mh1
          "
          onClick={() => handleDownloadRow(contact)}
          title="Download"
        >
          <i className="fas fa-download f4 green hover-dark-green"></i>
        </button>

       

      </td>
    </tr>
  );
};

export default ReadOnlyRow;